import { t } from 'i18next'
import { z } from 'zod'

export const GenericDocumentFormat = z
  .string()
  .transform((v) => v.replaceAll(/[^a-zA-Z0-9]/g, ''))

export const GenericDocument = GenericDocumentFormat.pipe(
  z.string().regex(/^(?!^0+$)[a-zA-Z0-9]{3,20}$/, {
    message: t('general.form.documentInvalid')
  })
)
